import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import style from './CoatingStep3Style.module.css';
import { Checkbox } from '@/components/pages/CarWashHand/Inputs/Checkbox';
import { Button } from '@/components/uiParts/Button';
import {
  CoatingStep3FormData,
  useCoatingStep3,
} from '@/hooks/api/coating/useCoatingStep3';
import { CoatingCourseItem } from '@/types/api/coatingApi';

interface Props {
  step3Data: CoatingStep3FormData;
  courseItem: CoatingCourseItem | undefined;
  onSubmit: (data: CoatingStep3FormData) => void;
  onClickCancel: () => void;
}

export const CoatingStep3: FC<Props> = ({
  step3Data,
  courseItem,
  onSubmit,
  onClickCancel,
}) => {
  const { formMethods } = useCoatingStep3(step3Data);
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={style['container']}>
          <h2 className={style['input-label']}>
            以下の注意事項をご確認の上、チェックを入れてください
            <span
              className={`${style['input-label-tips']} ${style['required']}`}
            >
              必須
            </span>
          </h2>

          {/* 傷残りクレーム不受理の同意 */}
          <div className={style['input-group']}>
            <h2 className={style['input-label']}>
              コーティング施工後、既存の傷や磨きで除去しきれない傷が残る可能性がございます。これらに関するクレームはお受けできません。
            </h2>
            <Checkbox
              value={true}
              name="scratchClaimConsent"
              isBoolean
              className="margin-top"
            >
              確認・同意しました
            </Checkbox>
          </div>

          {/* 追加料金発生の同意 */}
          <div className={style['input-group']}>
            <h2 className={style['input-label']}>
              お車の塗装状態や汚れ具合によっては、追加料金が発生する場合がございます。施工前にお見積もりの上、ご連絡いたします。
            </h2>
            <Checkbox
              value={true}
              name="extraChargeConsent"
              isBoolean
              className="margin-top"
            >
              確認・同意しました
            </Checkbox>
          </div>

          {/* 日程注意確認 */}
          <div className={style['input-group']}>
            <h2 className={style['input-label']}>
              場所や日時によっては施工日の回答に時間を要する場合やスタッフから連絡が入る場合がございます。
            </h2>
            <p className={style['sub-text']}>
              ※土日・祝日は翌平日以降に日程調整となります。
            </p>
            <Checkbox
              value={true}
              name="dateAnnotation"
              isBoolean
              className="margin-top"
            >
              確認しました
            </Checkbox>
          </div>

          {/* 悪天候時連絡確認 */}
          <div className={style['input-group']}>
            <h2 className={style['input-label']}>
              作業日が悪天候で作業が難しい場合、施工業者から連絡をいたします。施工業者へお客様の連絡先を提供させていただきます。
            </h2>
            <Checkbox
              value={true}
              name="badWeather"
              isBoolean
              className="margin-top"
            >
              確認しました
            </Checkbox>
          </div>

          {/* キャンセル料確認 */}
          <div className={style['input-group']}>
            <h2 className={style['input-label']}>
              ご予約後のキャンセルには、料金（コース＋オプション）に応じたキャンセル料が発生します。
            </h2>
            <ul className={style['notice-box-list']}>
              <li>9日前〜4日前：10%</li>
              <li>3日前〜前日：30%</li>
              <li>当日：100%</li>
            </ul>
            <Checkbox
              value={true}
              name="cancelFee"
              isBoolean
              className="margin-top"
            >
              確認しました
            </Checkbox>
          </div>

          {/* 注意書き */}
          <div className={style['notice-box']}>
            <h4 className={style['notice-box-title']}>ご注意事項</h4>
            <ul className={style['notice-box-list']}>
              <li>
                施工エリアによっては別途地域追加料金が発生する場合があります。
              </li>
              <li>
                Nissan・Honda車、トヨタ202ブラックなど一部車種は磨きオプション（60分以上）が必須となる場合があります。
              </li>
              <li>
                ウィンドウコーティングオプションの施工対象は、フロントウィンドウおよび前方両サイドウィンドウとなります。
              </li>
              <li>
                施工後、BRILA施工完了のステッカーをリアウィンドウ右下部分に貼り付け、BRILAオーナーズカードを社内に配置させていただきます。
              </li>
            </ul>
          </div>

          <div className={style['button-group']}>
            <Button text="次へ" type="submit" disabled={!isValid} />
            <Button
              style={{
                color: '#232323',
                backgroundColor: '#fff',
                marginTop: '8px',
              }}
              text="キャンセル"
              onClick={onClickCancel}
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
